import React, { useContext } from "react"
import styled from "styled-components"
import GameContext from "../../../Context/GameContext"
import { PlayerEnergy } from "./PlayerEnergy"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  grid-column: 2/3;
  padding: 10px 15px 15px 15px;
  background-color: ${props => props.theme.colors?.host_players_background};
  border-radius: 10px;
  border: 1px solid ${props => props.theme.colors?.host_players_border};
  font-size: 14px;
`

const PlayersWrap = styled.div`
  display: flex;
  column-gap: 10px;
  margin-top: 5px;
  align-items: end;
`

const PlayerWrap = styled.div`
  width: 100px;
`

const HostWrap = styled.div`
  width: 120px;
`

const Message = styled.div`
  font-size: 16px;
`

const PlayerName = styled.div`
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
`

export const Players = ({ message }) => {
  const { gameState } = useContext(GameContext)
  const players = gameState.players
  const host = gameState.host
  return (
    <Wrap>
      {message && <Message>{message}</Message>}
      <PlayersWrap>
        {players.map((player, index) => {
          return (
            <PlayerWrap key={index}>
              <PlayerName>{player.name}</PlayerName>
              <PlayerEnergy player={player} />
            </PlayerWrap>
          )
        })}
        <HostWrap>
          <PlayerName>{host.name}</PlayerName>
          <PlayerEnergy player={host} isHost />
        </HostWrap>
      </PlayersWrap>
    </Wrap>
  )
}
